export default __webpack_public_path__ + "static/media/reward.65c0432f.svg";